var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBynder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 29 22",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.816.072c-2.016 0-3.888.864-5.112 2.304L7.56 11.52 4.968 8.928c-.432-.504-.72-1.152-.72-1.8 0-1.584 1.224-2.808 2.808-2.808.72 0 1.296.216 1.8.72l.288.288.36.36 2.232-2.232.648-.648-.576-.576-.216-.216C10.296.72 8.64.072 6.84.072 3.096.072 0 3.096 0 6.84c0 1.728.648 3.312 1.656 4.536l5.832 5.904 12.24-12.24c.504-.432 1.152-.72 1.8-.72a2.735 2.735 0 012.736 2.736c0 .72-.216 1.296-.72 1.8l-7.992 8.136c-.288.36-.792.504-1.224.504-.504 0-.936-.216-1.224-.504l-.648-.576-2.88 2.88.576.576c1.08 1.08 2.52 1.728 4.104 1.728s3.024-.648 4.104-1.728l8.496-8.496c1.008-1.152 1.656-2.808 1.656-4.536.144-3.744-2.952-6.768-6.696-6.768z",
    fill: "#fff"
  })));
}

export default SvgBynder;